import React from "react";

import VacancySectionBlock from "./VacancySectionBlock";

const VacancyAboutUniversityBlock = () => (
  <VacancySectionBlock
    sectionTitle="About University"
    field="aboutUniversity"
    listKey="description"
    listLabel="Paragraphs"
    addButtonTitle="Add paragraph"
  />
);

export default VacancyAboutUniversityBlock;
